








































































import { computed, defineComponent, ref } from "@nuxtjs/composition-api";
import { useCheckoutAddress } from "~/stores/checkout";
import JetInput from "../../atoms/Input/JetInput.vue";

export default defineComponent({
  name: "AddressForm",
  components: {
    JetInput,
  },
  setup() {
    const { addressForm } = useCheckoutAddress();
    const zipCodeError = ref("");
    const isFetchingAddress = ref(false);

    const isAddressBlocked = computed(
      () => isFetchingAddress.value || zipCodeError.value !== ""
    );

    const isSubmitDisabled = computed(() => {
      return (
        !addressForm.value.postcode ||
        !addressForm.value.telephone ||
        !addressForm.value.street ||
        !addressForm.value.apartment ||
        !addressForm.value.city ||
        !addressForm.value.region ||
        !addressForm.value.country_code ||
        zipCodeError.value !== ""
      );
    });

    const searchAddress = async (zipCode: string) => {
      zipCodeError.value = "";
      if (zipCode.length !== 8) {
        zipCodeError.value = "Invalid Zip Code length.";
        return;
      }

      isFetchingAddress.value = true;
      try {
        const response = await fetch(
          `https://viacep.com.br/ws/${zipCode}/json/`
        );
        const data = await response.json();
        if (data.erro) {
          zipCodeError.value = "CEP not found.";
          return;
        }
        addressForm.value.street = data.logradouro;
        addressForm.value.city = data.localidade;
        addressForm.value.region = data.uf;
      } catch {
        zipCodeError.value = "Error fetching address.";
      } finally {
        isFetchingAddress.value = false;
      }
    };

    const clearAddressFields = () => {
      addressForm.value.street = "";
      addressForm.value.city = "";
      addressForm.value.region = "";
    };

    const handleSubmit = () => {
      if (zipCodeError.value) {
        alert("Please fix the errors before submitting.");
        return;
      }
      console.log("Form submitted", addressForm.value);
    };

    return {
      addressForm,
      isAddressBlocked,
      searchAddress,
      zipCodeError,
      handleSubmit,
      isSubmitDisabled,
      clearAddressFields,
      isFetchingAddress,
    };
  },
});
